import { Api } from 'api';
import { callApi } from 'root/appSaga';
import { takeEvery, put, all } from 'redux-saga/effects';
import * as paymentMethodActions from 'features/paymentmethods/paymentMethodActions';
import { SagaGenerator } from 'types';

export function* paymentMethodSaga(): SagaGenerator {
    return yield all([
        takeEvery(paymentMethodActions.CREATE_PAYMENT_METHOD_START, createPaymentMethod),
        takeEvery(paymentMethodActions.UPDATE_PAYMENT_METHOD_START, updatePaymentMethod),
    ]);
}

export function* createPaymentMethod(params: ReturnType<typeof paymentMethodActions.createPaymentMethod>): SagaGenerator {
    try {
        const cardDetails = params.payload.cardDetails;
        yield callApi(Api.createPaymentMethod, cardDetails);
        yield put(paymentMethodActions.createPaymentMethodCompleted());
    } catch (error) {
        yield put(paymentMethodActions.createPaymentMethodError(error));
    }
}

export function* updatePaymentMethod(params: ReturnType<typeof paymentMethodActions.updatePaymentMethod>): SagaGenerator {
    try {
        const cardDetails = params.payload.cardDetails;
        yield callApi(Api.updatePaymentMethod, cardDetails);
        yield put(paymentMethodActions.updatePaymentMethodCompleted());
    } catch (error) {
        yield put(paymentMethodActions.updatePaymentMethodError(error));
    }
}
